import { render, staticRenderFns } from "./wxShare.vue?vue&type=template&id=0739daec"
import script from "./wxShare.vue?vue&type=script&lang=js"
export * from "./wxShare.vue?vue&type=script&lang=js"
import style0 from "./wxShare.vue?vue&type=style&index=0&id=0739daec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports